<script lang="ts">
	import { t } from 'svelte-i18n';
	import type { InputEmailProps } from '@wiseed/wikit';
	import { InputEmail } from '@wiseed/wikit';
	import { snackbar } from '@wiseed/wikit';
	import { APIEndpoints } from '../enums/APIEndpoints';
	import { AlertSuccess } from '@wiseed/wikit';
	import { error } from '@sveltejs/kit';
	import { ButtonBoxTextColor } from '@wiseed/wikit';

	export let hasSubscribe = false;
	export let hasTitle = true;

	let fetching = false;

	let emailProps: InputEmailProps = {
		placeholder: $t('newsletter.placeholder'),
		classNames: 'flex-initial',
		required: true
	};

	const handleSubmit = async () => {
		fetching = true;
		const res = await fetch(APIEndpoints.PLATEFORME(`newsletter?email=${emailProps.value}`));

		if (res.ok) {
			hasSubscribe = true;
			fetching = false;
		} else {
			fetching = false;
			const json = await res.json();
			snackbar.danger($t('newsletter.error'));
			error(res.status, json);
		}
	};
</script>

<div class="space-y-3 md:space-y-4">
	{#if hasTitle}
		<h2 class="text-center md:w-full">{$t('newsletter.label')}</h2>
	{/if}
	{#if !hasSubscribe}
		<div class="space-y-3 flex flex-col md:flex-row md:justify-between md:space-x-4 md:space-y-0">
			<InputEmail bind:props={emailProps} />
			<div class="bg-text rounded-lg flex-shrink-0">
				<ButtonBoxTextColor
					props={{
						label: $t('forms.submit'),
						fetching: fetching,
						disabled: !emailProps.validation?.valid,
						classNames: 'justify-center text-primary'
					}}
					on:click={() => handleSubmit()}
				/>
			</div>
		</div>
	{:else}
		<AlertSuccess label={$t('newsletter.subscribed')} />
	{/if}
</div>
